import { IMenu } from '@uw/themes/models/menu.model';
import { takeUntil, BehaviorSubject, Subject } from 'rxjs';
import { AuthService } from './../../core/services/auth.service';
import { Injectable, OnDestroy } from '@angular/core';
import * as objectPath from 'object-path';
import { AuthUser } from '@uw/core/models/auth.user.model';
import { MenuConfig } from '@uw/config/menu.config';
import { AccessControlService } from '@uw/core/services/access-control.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService implements OnDestroy {

  donarSubMenuShow$ = new BehaviorSubject(false);
  sidemenuLinkClicked$ = new BehaviorSubject(false);
  menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  destroy$ = new Subject();
  showWorkflow: boolean = false;
  menuClick$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  mastnacSubMenuEnable = false;
  locked = false;
  hideDynamicMenu$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor(private authService: AuthService, private accessControlService: AccessControlService) {
    this.authService.getUserState().subscribe(user => {
      if (user)
        this.loadMenu();
    });
  }

  loadMenu() {
    const menuItems: any[] = objectPath.get(new MenuConfig().configs, 'aside');
    const filteredMenuItems: any[] = this.accessControlService.applyMenuPermissions(menuItems);
    const filteredMenuItemsByRoles: any[] = this.accessControlService.filterMenuRoleRestriction(filteredMenuItems);
    this.menuList$.next(filteredMenuItemsByRoles);
  }

  showDonarSubMenu(value: boolean) {
    this.donarSubMenuShow$.next(value);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  hideDynamicMenu() {
    this.hideDynamicMenu$.next(true);
  }

  setMastnacAvailable(value: boolean) {
    this.mastnacSubMenuEnable = value;
  }

  setCustomerLocked(value: boolean) {
    this.locked = value;
  }

  onMenuClick(menuItem: string) {
    this.menuClick$.next(menuItem);
  }

  closeSideMenu(){
    this.sidemenuLinkClicked$.next(true);
  }

  menuClicked = () => this.menuClick$.asObservable();
  donarSubMenuClick = () => this.donarSubMenuShow$.asObservable();
  menuLinkClicked = () => this.sidemenuLinkClicked$.asObservable();
}
